import { Teacher, Student } from '../types/user';

export const isTeacher = (user: any): user is Teacher => {
  return user?.role === 'teacher' || user?.role === 'schoolAdmin' || user?.role === 'superAdmin';
};

export const isStudent = (user: any): user is Student => {
  return user?.role === 'student';
}; 